var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { SourceType } from "../../../../../models/queries/queries.models";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import * as Enumerable from "linq";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { Router } from "aurelia-router";
import { RouterConstants } from "../../../../../configuration/router.constants";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { UserClientService } from "../../../../../services/authentication/user-client.service";
import { LotteryPlatformClaims } from "../../../../../constants/modules/lotteryplatform.claims";
import { LotteryBrandsOperatorDialog } from "../../lottery/dialogs/brandlotteryoperator-dialog-host";
import { MessageDialogModel } from "../../../../../models/lookups/lookup.models";
import { BrandClientService } from "../../../../../services/modules/brand-client.service";
var BrandLotteries = /** @class */ (function (_super) {
    __extends(BrandLotteries, _super);
    function BrandLotteries(notificationService, i18N, queriesService, dialogClient, router, userClientService, lotteryOperatorDialog, brandClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.queriesService = queriesService;
        _this.dialogClient = dialogClient;
        _this.router = router;
        _this.userClientService = userClientService;
        _this.lotteryOperatorDialog = lotteryOperatorDialog;
        _this.brandClientService = brandClientService;
        _this.removeLastVisitedTabCache = true;
        return _this;
    }
    BrandLotteries.prototype.isItemABrand = function () {
        return 'brandId' in this.item;
    };
    BrandLotteries.prototype.hasManageBrandSubscription = function () {
        return this.userClientService.currentUser.allowedClaims.find(function (x) { return x.permission == LotteryPlatformClaims.ManageLotterySubscription; });
    };
    BrandLotteries.prototype.onActivated = function (item) {
        this.reLoad(item);
    };
    BrandLotteries.prototype.reLoad = function (item) {
        var _this = this;
        var isBrand = 'brandId' in item;
        var path = isBrand ? "BrandLotteries" : "OperatorLotteries";
        if (!isBrand) {
            this.item.isEditable = true;
        }
        this.queriesService.getEntityModels().then(function (models) {
            var e_1, _a;
            var columns = [];
            var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == path; });
            try {
                for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item_1 = _c.value;
                    var column = QueriesEditor.generateDefaultColumn(item_1, selectedModel);
                    columns.push(column);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var oDataUrl = 'brandId' in item ? "/odata/".concat(path, "?$filter=brandId eq ").concat(item.brandId, " and isSubscribed eq true")
                : "/odata/".concat(path, "?$filter=operatorId eq ").concat(item.operatorId);
            _this.queriesService.getData(oDataUrl).then(function (lotteryDataResponse) {
                _this.itemSource = {
                    source: lotteryDataResponse.value,
                    sourceType: SourceType.Collection,
                    columns: columns,
                    groupInitialFilters: true
                };
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }).catch(function (error) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    Object.defineProperty(BrandLotteries.prototype, "canDragDrop", {
        get: function () {
            return this.item && "brandId" in this.item;
        },
        enumerable: false,
        configurable: true
    });
    BrandLotteries.prototype.itemMoved = function (args) {
        var e_2, _a;
        if (this.canDragDrop && args && args.detail) {
            var brand = this.item;
            var lotteries = Enumerable.from(brand.activeBrandLotteries).where(function (x) { return x.isSubscribed; }).toArray();
            var brandLotteryId = args.detail.item.brandLotteryId;
            var sequenceNumber = Number(args.detail.toIndex) + 1;
            var count = 1;
            var oldSequenceNumber = Enumerable.from(lotteries).where(function (x) { return x.brandLotteryId == brandLotteryId; }).select(function (x) { return x.sequenceNumber; }).firstOrDefault();
            var difference = oldSequenceNumber - sequenceNumber;
            var current = Enumerable.from(lotteries).firstOrDefault(function (x) { return x.brandLotteryId == brandLotteryId; });
            current.sequenceNumber = sequenceNumber + (difference >= 1 ? -0.5 : 0.5);
            var orderedLotteries = Enumerable.from(lotteries).orderBy(function (x) { return x.sequenceNumber; }).toArray();
            try {
                for (var orderedLotteries_1 = __values(orderedLotteries), orderedLotteries_1_1 = orderedLotteries_1.next(); !orderedLotteries_1_1.done; orderedLotteries_1_1 = orderedLotteries_1.next()) {
                    var lottery = orderedLotteries_1_1.value;
                    lottery.sequenceNumber = count;
                    var dgItem = Enumerable.from(this.dataGrid.itemsCollection).firstOrDefault(function (x) { return x.item.brandLotteryId == lottery.brandLotteryId; });
                    if (dgItem)
                        dgItem.item.sequenceNumber = count;
                    var uowLottery = Enumerable.from(brand.brandLotteries).firstOrDefault(function (x) { return x.brandLotteryId == lottery.brandLotteryId; });
                    if (uowLottery)
                        uowLottery.sequenceNumber = count;
                    count = count + 1;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (orderedLotteries_1_1 && !orderedLotteries_1_1.done && (_a = orderedLotteries_1.return)) _a.call(orderedLotteries_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            this.dataGrid.itemsCollection = Enumerable.from(this.dataGrid.itemsCollection).orderBy(function (x) { return x.item.sequenceNumber; }).toArray();
        }
    };
    BrandLotteries.prototype.addLottery = function () {
        return __awaiter(this, void 0, void 0, function () {
            var brandOrOperatorByGames;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        brandOrOperatorByGames = {
                            brandId: "brandId" in this.item ? this.item.brandId : null,
                            operatorId: 'operatorId' in this.item ? this.item.operatorId : null,
                            byLottery: true,
                            byInstantGames: false,
                            byBundles: false,
                            bySyndicates: false,
                            bySweepstakes: false
                        };
                        // check saved margin values in database to subscribe the instant games 
                        return [4 /*yield*/, this.brandClientService.AreMarginValuesValid(brandOrOperatorByGames).then(function (canSubscribe) {
                                if (canSubscribe) {
                                    _this.notificationService.show("Validation Error!", "Cannot be able to subscribe to lotteries since margins are not yet set. Please set the margin values and save it.", NotificationType.Error);
                                    return;
                                }
                                else {
                                    if (_this.isItemABrand()) {
                                        require("../dialogs/manage-lotteries-dialog");
                                        _this.dialogClient.show(DialogServiceConstants.URLs.ManageLotteriesDialog, _this);
                                    }
                                    else {
                                        require("../dialogs/manage-lotteries-operator-dialog");
                                        _this.dialogClient.show(DialogServiceConstants.URLs.ManageOperatorLotteriesDialog, _this);
                                    }
                                }
                            })];
                    case 1:
                        // check saved margin values in database to subscribe the instant games 
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BrandLotteries.prototype.reloadDataGrid = function () {
        this.dataGrid.reloadData();
    };
    BrandLotteries.prototype.onItemSelected = function (x) {
        return __awaiter(this, void 0, void 0, function () {
            var item, brandsAndOperatorsModel, brandCurrencyLength, messageModel, operatorMarginSyndicate, platformMarginSyndicate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = x.detail.item;
                        if (!('operatorId' in item && 'operator' in item)) return [3 /*break*/, 2];
                        brandsAndOperatorsModel = {
                            lotteryId: item.lotteryId,
                            lotteryName: item.lottery,
                            operatorId: item.operatorId,
                            pricingModelBrandId: 0
                        };
                        return [4 /*yield*/, this.lotteryOperatorDialog.createDataGridList(brandsAndOperatorsModel, 0).then(function (e) { return e; })];
                    case 1:
                        brandCurrencyLength = _a.sent();
                        // if brandCurrencyLength not equal 0, meaning the brands of this lotteries set by operator level
                        if (brandCurrencyLength != 0) {
                            this.removeLastVisitedTabCache = false;
                            this.router.navigateToRoute(RouterConstants.RouteNames.ManageLottery, {
                                id: item.lotteryId,
                                operatorId: item.operatorId,
                                operatorName: item.operator,
                                operatorDefaultCurrencyId: item.defaultCurrencyId,
                                isOpenedFromLotteryAdmin: false,
                                isOpenedFromBrandAdmin: this.isItemABrand()
                            });
                        }
                        else { // this lotteries are set only brand level.Give Indication to the user to do anything only from brand level.
                            // showing pop up
                            require("../../dialogs/message-dialog");
                            messageModel = new MessageDialogModel();
                            messageModel.isHtmlMessage = true;
                            messageModel.message = "alert-message-for-operator";
                            messageModel.messageTranslateProps = {
                                lotteryName: item.lottery
                            };
                            this.dialogClient.show(DialogServiceConstants.URLs.MessageConfirmationDialog, messageModel);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.removeLastVisitedTabCache = false;
                        operatorMarginSyndicate = this.item.syndicatesOperatorMargin || this.item.operator.syndicatesOperatorMargin;
                        platformMarginSyndicate = this.item.syndicatesPlatformMargin || this.item.operator.syndicatesPlatformMargin;
                        this.router.navigateToRoute(RouterConstants.RouteNames.ManageLottery, {
                            canCreateSyndicates: platformMarginSyndicate && operatorMarginSyndicate,
                            brandLanguages: item.brandLanguages ? item.brandLanguages.split(",").map(function (x) { return Number(x); }) : [],
                            id: item.lotteryId,
                            brandId: item.brandId,
                            brandName: item.brandName,
                            operatorId: item.operatorId,
                            operatorName: item.operator,
                            brandTemplateInternalName: item.brandTemplateInternalName,
                            brandThemeInternalName: item.brandThemeInternalName,
                            brandDefaultCurrencyId: item.defaultCurrencyId,
                            isOpenedFromLotteryAdmin: false,
                            isOpenedFromBrandAdmin: this.isItemABrand()
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrandLotteries = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            QueriesClientService, DialogClientService, Router,
            UserClientService, LotteryBrandsOperatorDialog,
            BrandClientService])
    ], BrandLotteries);
    return BrandLotteries;
}(ChildComponent));
export { BrandLotteries };
